// Privacy sanitize for parent photos (#18). Re-encoding through a canvas
// strips ALL metadata (EXIF GPS, device info, orientation tags) — the raw
// upload path leaked GPS to GCS and on to the vision processor. Also caps
// the long edge; DeepSeek vision downsamples far below this anyway, so it
// only ever speeds the upload. Output is always JPEG.
const MAX_EDGE = 2200;
const QUALITY = 0.85;

export async function sanitizeImage(file: File): Promise<Blob> {
  try {
    const bmp = await createImageBitmap(file, { imageOrientation: "from-image" });
    const scale = Math.min(1, MAX_EDGE / Math.max(bmp.width, bmp.height));
    const w = Math.round(bmp.width * scale);
    const h = Math.round(bmp.height * scale);
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext("2d");
    if (!ctx) return file;
    ctx.drawImage(bmp, 0, 0, w, h);
    bmp.close();
    const blob = await new Promise<Blob | null>((res) =>
      canvas.toBlob(res, "image/jpeg", QUALITY),
    );
    // Only accept the re-encode if it actually happened and isn't absurdly small.
    if (blob && blob.size > 1024) return blob;
    return file;
  } catch {
    // Non-bitmap input (shouldn't happen; intake validates) or canvas OOM:
    // upload raw — storage.rules + 7d lifecycle still bound the exposure.
    return file;
  }
}
